//React
import * as React from "react";
import { connect } from "react-redux";

//MainStore
import { MainStore } from "../../store/MainStore";

//React Components
import { Typography, MenuItem } from "material-ui";
import Avatar from "material-ui/Avatar";
import Checkbox from "material-ui/Checkbox";
import Select from "material-ui/Select";
import ExpandMoreIcon from "material-ui-icons/ExpandMore";
import Divider from "material-ui/Divider";
import ExpansionPanel, { ExpansionPanelDetails, ExpansionPanelSummary } from "material-ui/ExpansionPanel";
import { FormControl } from "material-ui/Form";
import Input, { InputLabel } from "material-ui/Input";
import List, { ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText } from "material-ui/List";

//Components
import DataTable from "../components/DataTable";

//Icons
import { Build, LightbulbOutline, Power, Tab } from "material-ui-icons";

//Managers
import { StyleManager } from "./../../managers/StyleManager";

//Framework
import { Category_e } from "../../framework/Category";

//Style
const styles = StyleManager.getStyles().MaterialsView;

const materialsCategories = [
    {
        "icon": Category_e.MATERIALS,
        "name": "Outillage",
        "state": "Outillage"
    },
    {
        "icon": Category_e.CABLES,
        "name": "Câbles",
        "state": "Câbles"
    },
    {
        "icon": Category_e.LIGHTS,
        "name": "Luminaires",
        "state": "Luminaires"
    },
    {
        "icon": Category_e.BOARDS,
        "name": "Tableaux",
        "state": "Tableaux"
    }
];

const renderMaterialIcon = (category) => {
    if (category === Category_e.BOARDS) {
        return (<Tab />);
    }
    if (category === Category_e.CABLES) {
        return (<Power />);
    }
    if (category === Category_e.LIGHTS) {
        return (<LightbulbOutline />);
    }
    if (category === Category_e.MATERIALS) {
        return (<Build />);
    }
    return <Build />;
};

interface MaterialsState {
    checked: string[];
    expandedRows: Array<any>;
    filterProduct: string;
    location: string;
    sorting: object;
}

interface MaterialProps {
    refresh: any;
    warehouses?: any;
}

/**
 * @description Contain the Materials View
 * @author Lucas Fridez <lfridez@artionet.com>
 * @export
 * @class Materials
 * @extends {React.Component}
 */
export default connect<{}, {}, MaterialProps>((state) => state)(class Materials extends React.Component<MaterialProps, MaterialsState> {

    private changeExpandedDetails = null;

    /**
     * Creates an instance of Materials.
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param {any} props
     * @memberof Materials
     */
    constructor(props) {
        super(props);
        this.state = {
            checked: ["Outillage", "Câbles", "Luminaires", "Tableaux"],
            expandedRows: [],
            filterProduct: "",
            location: "%",
            sorting: [
                {
                    columnName: "city",
                    direction: "asc"
                }
            ]
        };
        this.changeExpandedDetails = (expandedRows) => this.setState({ expandedRows });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.refresh != this.props.refresh) {
            MainStore.getProductListing(`categories=${encodeURIComponent(JSON.stringify(this.state.checked))}`, `${encodeURIComponent(this.state.location)}`);
        }
    }

    handleToggle = (value) => () => {
        const { checked } = this.state;
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        this.setState({
            checked: newChecked
        });

        MainStore.updateCategoriesChecked(newChecked);
    }

    handleChangeFilterProduct = (event) => {
        this.setState({ filterProduct: event.target.value });
    }

    handleChangeLocationSearch = (event) => {
        const newLocation = event.target.value;
        this.setState({
            location: newLocation
        });
        MainStore.updateListingLocation(newLocation);
    }

    handleRefresh = async (resolve, reject) => {
        try {
            MainStore.getProductListing(`categories=${encodeURIComponent(JSON.stringify(this.state.checked))}`, `${encodeURIComponent(this.state.location)}`);
            resolve();
        } catch (error) {
            reject();
        }
    }

    /**
     * @description Render the Materials View
     * @author Lucas Fridez <lfridez@artionet.com>
     * @returns Materials View
     * @memberof Materials
     */
    render() {
        const categoriesLength = materialsCategories.length;

        return (
            <div style={{ position: "relative" }}>
                <ExpansionPanel>
                    <ExpansionPanelSummary>
                        <Typography type="subheading" style={{
                            padding: 0,
                            textAlign: "center",
                            width: "100%"
                        }}>Filtrer</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails style={{ display: "inherit" }}>
                        {/* Form string search */}
                        <FormControl style={{width: "100%", marginBottom: 16}}>
                            <InputLabel>Nom de produit</InputLabel>
                            <Input
                                value={this.state.filterProduct}
                                onChange={(event) => this.handleChangeFilterProduct(event)} />
                        </FormControl>

                        {/* Location search */}
                        <FormControl  style={styles.inputContainer}>
                            <InputLabel htmlFor="select-multiple">Entrepôt</InputLabel>
                            <Select
                                value={this.state.location}
                                onChange={(event) => this.handleChangeLocationSearch(event)}
                                input={<Input id="search-location" />}
                            >
                                <MenuItem value="%">Tous</MenuItem>
                            {this.props.warehouses.warehouses.map((warehouse) => (
                                <MenuItem key={warehouse.id} value={warehouse.name}>{warehouse.name}</MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        {/* Category search */}
                        <List>
                            {materialsCategories.map((category, key) => (
                                <div key={key}>
                                    <ListItem button onClick={this.handleToggle(category.state)}>
                                        <ListItemAvatar>
                                            <Avatar>
                                                {renderMaterialIcon(category.icon)}
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={category.name}
                                        />
                                        <ListItemSecondaryAction>
                                            <Checkbox
                                                onChange={this.handleToggle(category.state)}
                                                checked={this.state.checked.indexOf(category.state) !== -1}
                                            />
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    {categoriesLength !== key + 1 && <Divider />}
                                </div>
                            ))}
                        </List>
                    </ExpansionPanelDetails>

                </ExpansionPanel>
                <DataTable
                    categories={this.state.checked}
                    location={this.state.location}
                    filters={[
                        { columnName: "name", value: this.state.filterProduct }
                    ]} />
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/UI/views/Materials.tsx